import { i as h, T as p, x as u, s as b } from "../../../lit-element-6iugfgmM.js";
import { e as m } from "../../../custom-element-wk-AooBb.js";
import { n } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-cclibrary.js";
import "../../../sp-tooltip-RAJ82M3n.js";
import g from "../../../events/SaveToLibraryIconClickEvent.js";
import { Localize as y } from "../../../lib/I18N.js";
const d = { "save-library-icon.save-to-library": "Save to Library" }, v = h`:host{color:var(--spectrum-gray-700);cursor:pointer}#trigger_button{--spectrum-actionbutton-background-color-default: none;--spectrum-actionbutton-background-color-down: none;--spectrum-actionbutton-background-color-focus: none;--spectrum-actionbutton-background-color-hover: none}sp-icon-cclibrary{color:var(--spectrum-gray-700)}@media (hover:hover){:host(:hover) sp-icon-cclibrary{color:var(--spectrum-blue-700)}}.trigger-button--light{--spectrum-actionbutton-content-color-default: var(--spectrum-gray-100);--spectrum-actionbutton-content-color-down: var(--spectrum-gray-100);--spectrum-actionbutton-content-color-focus: var(--spectrum-gray-100);--spectrum-actionbutton-content-color-hover: var(--spectrum-gray-100)}.trigger-button--light sp-icon-cclibrary{color:var(--spectrum-gray-100)}`;
var f = Object.defineProperty, w = Object.getOwnPropertyDescriptor, i = (l, r, a, e) => {
  for (var c, t = e > 1 ? void 0 : e ? w(r, a) : r, s = l.length - 1; s >= 0; s--) (c = l[s]) && (t = (e ? c(r, a, t) : c(t)) || t);
  return e && t && f(r, a, t), t;
};
let o = class extends y(b, d) {
  constructor() {
    super(...arguments), this.hideTooltip = !1, this.showLightButton = !1, this.showLabel = !1, this._renderTooltip = () => this._shouldHideTooltip() ? p : u`<sp-tooltip self-managed placement="top">${this.t("save-library-icon.save-to-library")}</sp-tooltip>`;
  }
  static get styles() {
    return [v];
  }
  render() {
    return u`<sp-action-button class="${this.showLightButton ? "trigger-button--light" : ""}" id="trigger_button" label="${this.t("save-library-icon.save-to-library")}" quiet @click="${this._handleButtonClick}"><sp-icon-cclibrary slot="icon" id="save_to_library_icon"></sp-icon-cclibrary>${this.showLabel ? this.t("save-library-icon.save-to-library") : p} ${this._renderTooltip()}</sp-action-button>`;
  }
  _shouldHideTooltip() {
    return this.showLabel || this.hideTooltip;
  }
  _handleButtonClick() {
    this.dispatchEvent(new g());
  }
};
i([n({ type: Boolean })], o.prototype, "hideTooltip", 2), i([n({ type: Boolean })], o.prototype, "showLightButton", 2), i([n({ type: Boolean })], o.prototype, "showLabel", 2), o = i([m("af-save-library-icon")], o);
const j = o;
export {
  j as default
};
//# sourceMappingURL=SaveLibraryIcon.js.map
